export default defineNuxtPlugin(() => {
  const { buildVersion, buildTime } = useRuntimeConfig().public
  console.log(`[landing2-ui] v${buildVersion} built ${buildTime}`)
})
